import { QueryWithViewMode } from 'src/utils/eventQueryUtils';
import { EntityWithTicketsQuery } from 'src/WebApiController';

import { CatalogDataContextProviderProps } from './CatalogDataContext.types';
import { CatalogDataContextV2Provider } from './CatalogDataContextV2';

export function CatalogDataContextProvider<
  TQuery extends EntityWithTicketsQuery & QueryWithViewMode,
>(props: CatalogDataContextProviderProps<TQuery>) {
  // If we need to test new Catalog vNext, we would add them here
  // For example:
  // return <CatalogDataContextV3Provider {...props} />;

  return <CatalogDataContextV2Provider {...props} />;
}
